/**
 * Created by neo on 31.01.2025
 */

export type MediaVideoAssets = {
  hls?: string;
  iframe?: string;
  player?: string;
  thumbnail?: string;
  mp4?: string;
};

/** @deprecated Use raw object instead */
export function createMediaVideoAssets(json?: Partial<MediaVideoAssets>): MediaVideoAssets {
  return {
    hls: json?.hls,
    iframe: json?.iframe,
    player: json?.player,
    thumbnail: json?.thumbnail,
    mp4: json?.mp4,
  };
}
